// MB-2753: "Refer a Friend" models. Local types until `yarn models:build` regenerates
// the shared api types into @mb/mb-api.

export interface IReferralSummaryModel {
  referralCode: string | null;
  canShare: boolean;
  // #1/#2: false when no referral program is active — the whole referral section is hidden.
  programActive: boolean;
  totalReferrals: number;
  bitecoinsEarnedFromReferrals: number;
  // Figma 14483:11827: current reward per referral shown on the share banner; null = program off.
  sharerBitecoinsAmount?: number | null;
  // "You've Saved" banner on the Bitecoins History page: bitecoins spent across finished
  // orders. Optional until `yarn models:build` regenerates the shared api types.
  totalSpentBitecoins?: number;
}

// Wallet history event types. Wire values match the api bitecoin_transactions ledger; 'referral'
// and 'order' are unchanged from MB-2753, spent/refund/expired were added with the ledger.
export enum EReferralHistoryType {
  Referral = 'referral',
  Order = 'order',
  Spent = 'spent',
  Refund = 'refund',
  Expired = 'expired',
}

export interface IReferralHistoryItemModel {
  type: EReferralHistoryType;
  bitecoinsAmount: number;
  date: string;
}

export interface IReferralHistoryCollection {
  data: IReferralHistoryItemModel[];
  meta: { count?: number };
}

export interface IReferralHistoryParams {
  offset?: number;
  limit?: number;
}
